<div
  class="h-dvh flex flex-col bg-gray-100 dark:bg-gray-900 transition-colors duration-200"
  (click)="closeDropdowns()">
  <!-- Navigation -->
  <nav
    class="shrink-0 bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700 transition-colors duration-200">
    <div class="mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex items-center h-16">
        <!-- Left side: Logo with environment badge -->
        <div class="flex items-center mr-6">
          <div class="flex-shrink-0 flex flex-col items-center">
            <img
              src="assets/logo.png"
              alt="Control Tower Logo"
              class="h-8 w-8" />
            <!-- Environment Badge (hidden in production) -->
            @if (environmentName && environmentName !== 'PRODUCTION') {
              <div
                class="mt-0.5 px-1.5 py-0.5 rounded text-[10px] font-bold tracking-wider"
                [ngClass]="environmentBadgeClass">
                {{ environmentName }}
              </div>
            }
          </div>
        </div>
        <!-- Left-Center: Search bar -->
        <div class="hidden sm:flex mr-6">
          <div class="relative w-80">
            <div
              class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg
                class="h-4 w-4 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
              </svg>
            </div>
            <input
              type="text"
              [(ngModel)]="searchQuery"
              (input)="onSearchInput()"
              placeholder="Search coming soon"
              disabled
              class="block w-full pl-10 pr-3 py-2 border border-gray-400 dark:border-gray-500 rounded-md leading-5 bg-white dark:bg-gray-700 placeholder-gray-500 dark:placeholder-gray-400 text-gray-900 dark:text-white focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-blue-600 focus:border-blue-600 text-sm opacity-50 cursor-not-allowed" />
          </div>
        </div>
        <!-- Left-Center: Navigation Links -->
        <div class="hidden sm:flex items-center space-x-8 mr-6">
          <a
            routerLink="/dashboard"
            routerLinkActive="nav-active"
            [routerLinkActiveOptions]="{ exact: true }"
            class="nav-link text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 hover:transform hover:-translate-y-0.5 hover:border-b-2 hover:border-blue-400 dark:hover:border-blue-500 px-3 pb-1 pt-3 text-sm font-medium transition-all duration-200 border-b-2 border-transparent">
            Dashboard
          </a>
          <a
            routerLink="/workflow"
            routerLinkActive="nav-active"
            class="nav-link text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 hover:transform hover:-translate-y-0.5 hover:border-b-2 hover:border-blue-400 dark:hover:border-blue-500 px-3 pb-1 pt-3 text-sm font-medium transition-all duration-200 border-b-2 border-transparent">
            Workflows
          </a>
          <a
            routerLink="/packages/official"
            routerLinkActive="nav-active"
            class="nav-link text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 hover:transform hover:-translate-y-0.5 hover:border-b-2 hover:border-blue-400 dark:hover:border-blue-500 px-3 pb-1 pt-3 text-sm font-medium transition-all duration-200 border-b-2 border-transparent">
            Components
          </a>
          <a
            routerLink="/images/official"
            routerLinkActive="nav-active"
            class="nav-link text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 hover:transform hover:-translate-y-0.5 hover:border-b-2 hover:border-blue-400 dark:hover:border-blue-500 px-3 pb-1 pt-3 text-sm font-medium transition-all duration-200 border-b-2 border-transparent">
            Images
          </a>
          <a
            routerLink="/releases"
            routerLinkActive="nav-active"
            class="nav-link text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 hover:transform hover:-translate-y-0.5 hover:border-b-2 hover:border-blue-400 dark:hover:border-blue-500 px-3 pb-1 pt-3 text-sm font-medium transition-all duration-200 border-b-2 border-transparent">
            Releases
          </a>
          <a
            routerLink="/plans"
            routerLinkActive="nav-active"
            [routerLinkActiveOptions]="{ exact: true }"
            class="nav-link text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 hover:transform hover:-translate-y-0.5 hover:border-b-2 hover:border-blue-400 dark:hover:border-blue-500 px-3 pb-1 pt-3 text-sm font-medium transition-all duration-200 border-b-2 border-transparent">
            Plans
          </a>
        </div>
        <!-- Spacer to push right items to the end -->
        <div class="flex-1"></div>
        <!-- Right side: User Profile -->
        <div class="flex items-center space-x-4">
          <!-- Health Heart Icon -->
          <div class="relative">
            <button
              (click)="navigateToSystemHealth()"
              class="bg-gray-100 dark:bg-gray-700 hover:bg-blue-100 dark:hover:bg-blue-800/50 rounded-md p-2 transition-colors"
              [ngClass]="{
                'text-green-600 dark:text-green-400': isSystemHealthy,
                'text-red-600 dark:text-red-400': !isSystemHealthy,
              }"
              title="System Health">
              <svg class="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fill-rule="evenodd"
                  d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"
                  clip-rule="evenodd"></path>
              </svg>
            </button>
          </div>
          <!-- Dark Mode Toggle -->
          <div class="relative">
            <button
              (click)="toggleDarkMode()"
              class="bg-gray-100 dark:bg-gray-700 hover:bg-blue-100 dark:hover:bg-blue-800/50 text-gray-700 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 rounded-md p-2 transition-colors"
              [title]="
                isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'
              ">
              <!-- Sun icon (shown in dark mode) -->
              @if (isDarkMode) {
                <svg
                  class="h-4 w-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"></path>
                </svg>
              }
              <!-- Moon icon (shown in light mode) -->
              @if (!isDarkMode) {
                <svg
                  class="h-4 w-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"></path>
                </svg>
              }
            </button>
          </div>
          <!-- Extra Menu (Hamburger) -->
          <div class="relative">
            <button
              (click)="toggleExtraMenu($event)"
              class="bg-gray-100 dark:bg-gray-700 hover:bg-blue-100 dark:hover:bg-blue-800/50 text-gray-700 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 rounded-md p-2 transition-colors"
              title="More">
              <svg
                class="h-4 w-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 6h16M4 12h16M4 18h16"></path>
              </svg>
            </button>
            <!-- Extra Menu Dropdown -->
            @if (isExtraMenuOpen) {
              <div
                class="absolute right-0 mt-2 w-56 bg-white dark:bg-gray-800 rounded-md shadow-lg py-1 z-50 border border-gray-200 dark:border-gray-700"
                (click)="$event.stopPropagation()">
                <div
                  class="px-4 py-2 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider border-b border-gray-200 dark:border-gray-700">
                  Extras
                </div>
                <a
                  routerLink="/plans"
                  (click)="isExtraMenuOpen = false"
                  class="block px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors">
                  <i
                    class="fas fa-clipboard-list mr-2 text-blue-600 dark:text-blue-400"></i>
                  Plans
                </a>
                <a
                  routerLink="/test-results-by-workflow"
                  (click)="isExtraMenuOpen = false"
                  class="block px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors">
                  <i
                    class="fas fa-list-check mr-2 text-green-600 dark:text-green-400"></i>
                  Test Results by Workflow
                </a>
                <a
                  routerLink="/release-health"
                  (click)="isExtraMenuOpen = false"
                  class="block px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                  data-testid="nav-release-health">
                  <i
                    class="fas fa-heart-pulse mr-2 text-rose-600 dark:text-rose-400"></i>
                  Release Health
                </a>
                <a
                  routerLink="/build-metrics"
                  (click)="isExtraMenuOpen = false"
                  class="block px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors">
                  <i
                    class="fas fa-chart-column mr-2 text-cyan-600 dark:text-cyan-400"></i>
                  Build Metrics
                </a>
                <div
                  class="border-t border-gray-200 dark:border-gray-700 mt-1 pt-1">
                  <div
                    class="px-4 py-1 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                    Admins
                  </div>
                  <a
                    routerLink="/release/in-flight"
                    (click)="isExtraMenuOpen = false"
                    class="block px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors">
                    <i
                      class="fas fa-plane-departure mr-2 text-amber-600 dark:text-amber-400"></i>
                    In-flight Publish
                  </a>
                </div>
                <div
                  class="border-t border-gray-200 dark:border-gray-700 mt-1 pt-1">
                  <div
                    class="px-4 py-1 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                    Developer Tools
                  </div>
                  <a
                    [href]="apiUrl + '/swagger'"
                    target="_blank"
                    rel="noopener"
                    class="block px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors">
                    <i
                      class="fas fa-code mr-2 text-green-600 dark:text-green-400"></i>
                    Swagger
                    <i
                      class="fas fa-external-link-alt text-xs ml-1 opacity-50"></i>
                  </a>
                  <a
                    [href]="apiUrl + '/api/metadata/swagger'"
                    target="_blank"
                    rel="noopener"
                    class="block px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors">
                    <i
                      class="fas fa-code mr-2 text-teal-600 dark:text-teal-400"></i>
                    Metadata Swagger
                    <i
                      class="fas fa-external-link-alt text-xs ml-1 opacity-50"></i>
                  </a>
                  <a
                    routerLink="/admin/hangfire"
                    (click)="isExtraMenuOpen = false"
                    class="block px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors">
                    <i
                      class="fas fa-tasks mr-2 text-orange-600 dark:text-orange-400"></i>
                    Hangfire
                  </a>
                </div>
              </div>
            }
          </div>
          <!-- User Profile -->
          <div class="relative">
            <!-- Loading indicator -->
            @if (isAuthLoading) {
              <div class="flex items-center space-x-2">
                <div
                  class="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-600"></div>
                <span class="text-sm text-gray-600 dark:text-gray-400"
                  >Signing in...</span
                >
              </div>
            }
            <!-- Fallback login button if auto-login fails -->
            @if (!isAuthLoading && !isAuthenticated) {
              <button
                (click)="login()"
                class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors">
                Sign In
              </button>
            }
            <!-- Show user profile if authenticated -->
            @if (!isAuthLoading && isAuthenticated) {
              <button
                (click)="toggleUserMenu($event)"
                class="flex items-center space-x-3 text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
                title="User menu">
                <div
                  class="h-8 w-8 rounded-full bg-gradient-to-r from-blue-400 to-blue-600 flex items-center justify-center text-white font-medium text-sm">
                  <span class="leading-none">{{ getUserInitials() }}</span>
                </div>
              </button>
            }
            <!-- User menu dropdown -->
            @if (isUserMenuOpen && isAuthenticated) {
              <div
                class="absolute right-0 mt-2 w-72 bg-white dark:bg-gray-800 rounded-md shadow-lg py-1 z-50 border border-gray-200 dark:border-gray-700"
                (click)="$event.stopPropagation()">
                <div
                  class="px-4 py-2 text-sm text-gray-900 dark:text-gray-100 border-b border-gray-200 dark:border-gray-700">
                  <div class="font-medium truncate">
                    {{ getUserDisplayName() }}
                  </div>
                  <div
                    class="text-gray-500 dark:text-gray-400 truncate text-xs">
                    {{ getUserEmail() }}
                  </div>
                </div>
                <a
                  (click)="goToUnderConstruction()"
                  class="block px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-blue-50 dark:hover:bg-blue-900/20 hover:text-blue-600 dark:hover:text-blue-400 transition-colors cursor-pointer">
                  Settings
                </a>
                <a
                  (click)="openPrivacyNotice()"
                  class="block px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-blue-50 dark:hover:bg-blue-900/20 hover:text-blue-600 dark:hover:text-blue-400 transition-colors cursor-pointer">
                  Privacy Notice
                  <i
                    class="fas fa-external-link-alt text-xs ml-1 opacity-50"></i>
                </a>
                <div
                  class="border-t border-gray-200 dark:border-gray-700"></div>
                <button
                  (click)="logout()"
                  class="w-full text-left block px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-blue-50 dark:hover:bg-blue-900/20 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
                  Sign out
                </button>
              </div>
            }
          </div>
        </div>
        <!-- Mobile menu button -->
        <div class="sm:hidden flex items-center ml-4">
          <button
            (click)="toggleMobileMenu()"
            class="text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 p-2">
            <svg
              class="h-6 w-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24">
              @if (!isMobileMenuOpen) {
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 6h16M4 12h16M4 18h16"></path>
              }
              @if (isMobileMenuOpen) {
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"></path>
              }
            </svg>
          </button>
        </div>
      </div>
      <!-- Mobile menu -->
      @if (isMobileMenuOpen) {
        <div class="sm:hidden">
          <div class="pt-2 pb-3 space-y-1">
            <!-- Mobile search -->
            <div class="px-3 pb-3">
              <div class="relative">
                <div
                  class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg
                    class="h-4 w-4 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                  </svg>
                </div>
                <input
                  type="text"
                  [(ngModel)]="searchQuery"
                  (input)="onSearchInput()"
                  placeholder="Search coming soon"
                  class="block w-full pl-10 pr-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md leading-5 bg-white dark:bg-gray-700 placeholder-gray-500 dark:placeholder-gray-400 text-gray-900 dark:text-white focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm" />
              </div>
            </div>
            <!-- Mobile navigation links -->
            <a
              routerLink="/"
              routerLinkActive="bg-blue-50 dark:bg-blue-900 border-blue-500 text-blue-700 dark:text-blue-200"
              [routerLinkActiveOptions]="{ exact: true }"
              class="border-transparent text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 hover:border-gray-300 hover:text-gray-800 dark:hover:text-gray-200 block pl-3 pr-4 py-2 border-l-4 text-base font-medium transition-colors">
              Dashboard
            </a>
            <a
              routerLink="/jobs"
              routerLinkActive="bg-blue-50 dark:bg-blue-900 border-blue-500 text-blue-700 dark:text-blue-200"
              class="border-transparent text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 hover:border-gray-300 hover:text-gray-800 dark:hover:text-gray-200 block pl-3 pr-4 py-2 border-l-4 text-base font-medium transition-colors">
              Jobs
            </a>
          </div>
        </div>
      }
    </div>
  </nav>
  <!-- Main Content -->
  <main class="flex-1 min-h-0 overflow-auto">
    <router-outlet></router-outlet>
  </main>
</div>

<!-- Global Toast Notifications -->
<app-toast-container></app-toast-container>
